import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';

import types from '../../common/model-api/types';
import JobDetail from './JobDetail.react';

import './progress.scss';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'jobView.title', 'defaultMessage': 'Job View'}
});

interface UserJobViewProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class UserJobView extends React.Component<UserJobViewProps> {

    typeName = 'jobs';

    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    render() {
        let job = this.props.user.job;

        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data: job},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <JobDetail job={job} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(UserJobView), (props) => {
    return props.user.job;
}), {
    initialVariables: {
        jobId: ''
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                job(id: $jobId) {
                    ${JobDetail.getFragment('job')}
                },
            }
        `,
    },
});
